export default __webpack_public_path__ + "static/media/page7.c2b09a3c.webp";